module.exports = __webpack_public_path__ + "static/media/vctr-small-up-arrow.5b8facb3.svg";